import { ApiClient } from "@/lib/client";

export const fetchPreviewTokenApi = async (tenant_id?: string, container?: string) => {
    const params: Record<string, string> = {};
    if (tenant_id) params.tenant_id = tenant_id;
    if (container) params.container = container;
    
    const res = await ApiClient.get("/core/tenant/get_media_url_token/", {
      params: Object.keys(params).length > 0 ? params : undefined,
    });
    return res.data.data;
};